module.exports = __webpack_public_path__ + "static/media/resource-7.d482c3ec.jpg";